import useOrientationFullScreen from "components/hooks/useOrientationFullScreen";
import React from "react";
import { useDispatch } from "react-redux";
import { openSlideWidgetAction } from "store/slides/actions";
import { useGetAllSlidesData } from "store/slides/selectors";
import styled from "styled-components";

const SlideWidget = ({ pageId = "", bookId = "", isShow  , onClick=()=>{} , btnStyle={} }) => {
  const dispatch = useDispatch();
  const getSlideData = useGetAllSlidesData();
  const filterData = getSlideData?.find((x) => x.book_id == bookId && x.page_id == pageId)
  const landscapeOrientation = useOrientationFullScreen();

  const handlerOpen = async (value) => {
    const widgetData = {
      open: true,
      pageId: pageId,
      bookId: bookId,
      data: filterData
    };
    await dispatch(openSlideWidgetAction(widgetData));
  };


  if(getSlideData?.length === 0 && filterData && Object.keys(filterData)?.length === 0){
    return null;
  }
  else{
    return (
      <>
        <div
          className={`cursorBtns ${landscapeOrientation && 'differnation-tool'} `}
          style={btnStyle}
          onClick={() => {
            handlerOpen(true);
            if(onClick) onClick();
          }}
        >
          Ebook Presentation
        </div>
      </>
    );
  }
};

export default SlideWidget;

const EbookPPTImage = styled.img`
  width: 30px;
  height: 30px;
`;
